"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTableSelectorHeaderCell = void 0;
var React = __importStar(require("react"));
var AcTableContext_1 = require("./AcTableContext");
var AcTableCheckAllButton_1 = require("./AcTableCheckAllButton");
var AcTableCheckDropdown_1 = require("./AcTableCheckDropdown");
var AcTableSelectorHeaderCell = function (_a) {
    var enableCustomHeaderSelector = _a.enableCustomHeaderSelector, enableAllRecordsSelector = _a.enableAllRecordsSelector, selectedRowCount = _a.selectedRowCount;
    var useAcTableMethods = AcTableContext_1.useAcTableContext();
    var selectedRowIds = (useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.selectedDataIds) || [];
    var renderSelector = function () {
        if (enableCustomHeaderSelector) {
            if (enableAllRecordsSelector) {
                return (React.createElement("div", { className: "mr-2" },
                    React.createElement(AcTableCheckAllButton_1.AcTableCheckAllButton, { selectedRowCount: selectedRowCount !== null && selectedRowCount !== void 0 ? selectedRowCount : 0, onClick: function () {
                            if (useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isAllRecordSelected) {
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.clearSelectedDataIds();
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.setIsAllRecordSelected(false);
                            }
                            else {
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.selectAllPageData();
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.setIsAllRecordSelected(true);
                            }
                        } })));
            }
            return (React.createElement("div", { className: "mr-3" },
                React.createElement(AcTableCheckDropdown_1.AcTableCheckDropdown, { selectedRowIds: selectedRowIds, onClickSelectedPageCheckAll: function () { return useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.selectAllPageData(); }, disabledSelectedPageCheckAll: useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isAllPageDataSelected, onClickSelectedPageUncheckAll: function () { return useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.deselectAllPageData(); }, disabledSelectedPageUncheckAll: !(useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isAllPageDataSelected), onClickAllPageUncheckAll: function () { return useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.clearSelectedDataIds(); }, disabledAllPageUncheckAll: selectedRowIds.length === 0 })));
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "mr-3 form-group" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("div", { className: "custom-control custom-checkbox", onClick: function () {
                            if (useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isAllPageDataSelected) {
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.deselectAllPageData();
                            }
                            else {
                                useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.selectAllPageData();
                            }
                        } },
                        React.createElement("input", { type: "checkbox", className: "custom-control-input", checked: useAcTableMethods === null || useAcTableMethods === void 0 ? void 0 : useAcTableMethods.isAllPageDataSelected, onChange: function () { } }),
                        React.createElement("label", { className: "custom-control-label" }))))));
    };
    return React.createElement("div", null, renderSelector());
};
exports.AcTableSelectorHeaderCell = AcTableSelectorHeaderCell;
exports.AcTableSelectorHeaderCell.displayName = 'AcTableSelectorHeaderCell';
//# sourceMappingURL=AcTableSelectorHeaderCell.js.map